/* ------------------------------------------------------------------
  File: CarouselTestPage.jsx
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-05-21
------------------------------------------------------------------ */

import { LuBriefcaseBusiness, LuCpu, LuFactory, LuTrendingUp } from "react-icons/lu";

import Carousel from "../../shared/components/ui/Carousel";
import SectionHeader from "../../shared/components/ui/SectionHeader";
import { InfoCard } from "../../shared/components/ui/Cards";

const carouselItems = [
  {
    id: "technology",
    icon: <LuCpu />,
    eyebrow: "Technology",
    title: "Digital Systems",
    description:
      "Building software platforms, dashboards, websites, APIs, and automation tools for modern organizations.",
  },
  {
    id: "engineering",
    icon: <LuFactory />,
    eyebrow: "Engineering",
    title: "Technical Solutions",
    description:
      "Supporting infrastructure, systems design, technical planning, and engineering implementation.",
  },
  {
    id: "investment",
    icon: <LuTrendingUp />,
    eyebrow: "Investment",
    title: "Strategic Growth",
    description:
      "Developing scalable companies across high-impact sectors with long-term value creation in mind.",
  },
  {
    id: "business",
    icon: <LuBriefcaseBusiness />,
    eyebrow: "Business",
    title: "Portfolio Development",
    description:
      "Creating and managing a growing portfolio of companies across priority growth sectors.",
  },
];

const CarouselTestPage = () => {
  return (
    <main>
      <section className="l-section l-section--base">
        <div className="l-container l-container--max l-stack l-stack--xl">
          <SectionHeader
            eyebrow="Carousel System"
            title="Carousel Component Test"
            text="Testing the reusable Accend carousel component with cards, controls, dots, autoplay, and responsive behavior."
          />

          <div className="l-stack l-stack--lg">
            <SectionHeader
              eyebrow="Test 01"
              title="Single Slide View"
              text="This checks the standard one-slide carousel behavior."
              titleAs="h3"
            />

            <Carousel
              items={carouselItems}
              slidesPerView={1}
              showControls
              showDots
              infinite
              label="Single slide carousel test"
              renderItem={(item) => (
                <InfoCard
                  icon={item.icon}
                  eyebrow={item.eyebrow}
                  title={item.title}
                  description={item.description}
                  variant="default"
                  hoverable
                  fullHeight
                />
              )}
            />
          </div>

          <div className="l-stack l-stack--lg">
            <SectionHeader
              eyebrow="Test 02"
              title="Two Slides Per View"
              text="This checks the carousel with two visible cards."
              titleAs="h3"
            />

            <Carousel
              items={carouselItems}
              slidesPerView={2}
              showControls
              showDots
              infinite
              label="Two slides carousel test"
              renderItem={(item) => (
                <InfoCard
                  icon={item.icon}
                  eyebrow={item.eyebrow}
                  title={item.title}
                  description={item.description}
                  variant="default"
                  hoverable
                  fullHeight
                />
              )}
            />
          </div>

          <div className="l-stack l-stack--lg">
            <SectionHeader
              eyebrow="Test 03"
              title="Three Slides Per View"
              text="This checks wider carousel layouts."
              titleAs="h3"
            />

            <Carousel
              items={carouselItems}
              slidesPerView={3}
              showControls
              showDots
              infinite
              label="Three slides carousel test"
              renderItem={(item) => (
                <InfoCard
                  icon={item.icon}
                  eyebrow={item.eyebrow}
                  title={item.title}
                  description={item.description}
                  variant="default"
                  hoverable
                  fullHeight
                />
              )}
            />
          </div>
        </div>
      </section>

      {/* <section className="l-section l-section--base surface--dark">
        <div className="l-container l-container--max l-stack l-stack--xl">
          <SectionHeader
            eyebrow="Dark Surface"
            title="Inverse Carousel Test"
            text="This checks carousel controls and dots on a dark section."
          />

          <Carousel
            items={carouselItems}
            slidesPerView={2}
            showControls
            showDots
            infinite
            variant="inverse"
            label="Dark surface carousel test"
            renderItem={(item) => (
              <InfoCard
                icon={item.icon}
                eyebrow={item.eyebrow}
                title={item.title}
                description={item.description}
                variant="inverse"
                hoverable
                fullHeight
              />
            )}
          />
        </div>
      </section> */}

      {/* <section className="l-section l-section--base">
        <div className="l-container l-container--max l-stack l-stack--xl">
          <SectionHeader
            eyebrow="Autoplay"
            title="Autoplay Carousel Test"
            text="This checks automatic slide movement and pause-on-hover behavior."
          />

          <Carousel
            items={carouselItems}
            slidesPerView={1}
            showControls
            showDots
            infinite
            autoPlay
            autoPlayDelay={3000}
            pauseOnHover
            label="Autoplay carousel test"
            renderItem={(item) => (
              <InfoCard
                icon={item.icon}
                eyebrow={item.eyebrow}
                title={item.title}
                description={item.description}
                variant="soft"
                hoverable
                fullHeight
              />
            )}
          />
        </div>
      </section> */}
    </main>
  );
};

export default CarouselTestPage;